import { FC, useCallback, useContext, useEffect } from 'react';
import { CenterAlignedLoader } from '@medly-components/core';
import { UserContext } from 'context/UserContext';
import { useCurrentUser } from 'hooks/user/useUser';
import Error from 'pages/Error';
import { MantaCareUser } from 'context/UserContext/types';
import { useLocation } from 'react-router-dom';

/**
 * RefreshUser responsible for refetching user details.
 */
export const RefreshUser: FC = ({ children }) => {
    const { setMantaCareUser } = useContext(UserContext);
    const location = useLocation();

    const updateUser = useCallback((data: MantaCareUser) => {
        setMantaCareUser(data);
    }, []);

    const { error, isLoading, mutate } = useCurrentUser({ onSuccess: updateUser });

    useEffect(() => {
        mutate();
    }, [location.pathname, mutate]);

    if (error) {
        return <Error />;
    }

    if (isLoading) {
        return (
            <main style={{ height: '100%' }}>
                <CenterAlignedLoader />
            </main>
        );
    }

    return <>{children}</>;
};
